<!--
soho-busyindicator needed here for paging.
-->
<div soho-busyindicator
  [style.height]="'100%'"
  [text]="' '"
  [blockUI]="true"
  [displayDelay]="20"
  [timeToComplete]="this.uiLoadingIndicatorTimeout"
  [transparentOverlay]="true"
  >
  @if (!showEmptyMessage) {
    <!-- USE FLEX LAYOUT -->
    <div class="scrollable-flex">
      <!-- FLEX CONTENT AREA -->
      <!--
      Setting class.card when list-view is in the main content causes it to display
      a little more like a grid. This is what we want in the case where the list-view
      is the end point of a screen.
      ---
      Examples: page panes, page panels, detail sections, etc..
      The only place we don't want this is if it's a cardList with detail sections.
      ---
      image-list class is for lazy loading images in the list view that scroll
      into view. The image-list is the observable that ngx-lazy-load-images will
      use to decide when an img element is in view then load that image lazily.
      -->
      <!-- taking out 'lazy-load-images' directive tag because images are not lazy loading on iOS -->
      <div class="scrollable-flex-content image-list" [style.overflow]="'auto'" [class.card]="showAsCard">
        <soho-listview
          #SohoListView
          selectable='{{selectionMode}}'
          disableItemDeactivation="'true'"
          [attr.data-automation-id]="sohoListViewAutomationId"
          (keydown)="onKeyDown($event)"
          (selected)="onItemsSelected($event)"
          (unselected)="onItemUnselected($event)"
          (itemactivated)="onItemActivated($event)"
          (rendered)="onRendered()"
          (itemdeactivated)="onItemDeactivated($event)"
          (click)="onItemClicked($event)"
          (dblclick)="onItemDoubleClicked($event)"
          (contextmenu)="onContextMenu($event)"
          >
          @for (data of dataViewSet?.data; track data; let rowIndex = $index) {
            <li soho-listview-item
              [attr.draggable]="implementsDragAndDrop ? 'true' : 'false'"
              (dragstart)="onDragged($event, data)"
              (dragend)="onDragEnd($event, data)"
              (keydown)="onListViewItemKeyDownEvent($event)"
              (click)="canTriggerItemSelectedEvent = true"
              tabindex="0"
              >
              <lm-list-card
                #LMListCard
                [listSpec]="_listSpec"
                [dataView]="data"
                [rowIndex]="rowIndex"
                (buildButtonMenu)="onBuildCardButtonMenu($event)"
                (uiLinkEvent)="onUILinkEvent($event)"
                (toolbarButtonEvent)="onToolbarButtonEvent($event)"
                (drillAroundEvent)="onDrillRowButtonClicked($event)">
              </lm-list-card>
            </li>
          }
          @if (showEmptyMessage) {
            <div soho-emptymessage
              style="display:initial"
              [emptyMessageOptions]="emptyMessage"
            ></div>
          }
        </soho-listview>
      </div>
      <!-- FLEX FOOTER -->
      @if (!hidePagerBar) {
        <div class="scrollable-flex-footer">
          <lm-list-pager-wrapper
            id="{{testVersion1 ? listSpec.busListSpec.id + '_pager' : null}}"
            [attributes]="pagerIdAttributes"
            [smallPageSizeSelector]="true"
            [pageSizeMenuSettings]="{ attachToBody: true }"
            [enableFirstButton]="hasFirstPage"
            [enablePreviousButton]="hasPreviousPage"
            [enableNextButton]="hasNextPage"
            [enableLastButton]="hasLastPage"
            [firstPageTooltip]="firstPageButtonTooltip"
            [previousPageTooltip]="previousPageButtonTooltip"
            [nextPageTooltip]="nextPageButtonTooltip"
            [lastPageTooltip]="lastPageButtonTooltip"
            [showPageSizeSelector]="showPageSizeSelector"
            [pageSize]="pageSize"
            [pageSizes]="pageSizes"
            (firstPage)="onFirstPage()"
            (previousPage)="onPreviousPage()"
            (nextPage)="onNextPage()"
            (lastPage)="onLastPage()"
            (pageSizeChange)="onPageSizeChange($event)"
          ></lm-list-pager-wrapper>
          @if (showCollapseButton$ | async) {
            <div class="pager-toolbar collapse-button">
              <button id="collapse-button"
                soho-button="icon"
                icon="collapse-app-tray"
                [ripple]="false"
                (click)="collapseList()"
                attr.data-automation-id="lm-{{listSpec.busListSpec.automationId}}-collapse-button"
                aria-label="{{ 'ReportFieldPickerDrawerCollapse' | translate }}"
                >
              </button>
            </div>
          }
        </div>
      }
    </div>
  } @else {
    <div soho-emptymessage [emptyMessageOptions]="emptyMessage"></div>
  }
</div>
<div #modalPlaceholder id="modalPlaceholder"></div>

<!-- button menu for cards, place outside of list so <li>'s aren't removed by listview DOM queries -->
@if (cardButtonMenuData && cardButtonMenuData.length > 0) {
  @for (buttonMenu of cardButtonMenuData; track buttonMenu; let i = $index) {
    <div class="popupmenu-wrapper">
      <!-- need a unique id for each menu, each menu can have different items visible depending on the row -->
      <ul #SohoPopupMenu soho-popupmenu
        id="lm-{{listSpec?.busListSpec?.id}}-list-view-card-button-menu-{{i}}"
        attr.data-automation-id="lm-{{listSpec.busListSpec.automationId}}-list-view-card-button-menu-{{i + 1}}">
        @for (b of buttonMenu; track b; let j = $index) {
          @if (b.isOpenExternal) {
            <li soho-popupmenu-item>
              <!-- httpUrl (external link)-->
              <a soho-popupmenu-label
                attr.data-automation-id="{{b.automationId}}-{{i + 1}}"
                [attr.href]="b.httpUrl"
                target="_blank"
                (click)="externalNavigation(b, $event)"
                >
                @if (b.icon) {
                  <svg soho-icon icon="{{b.icon}}"></svg>
                }
                {{b.actionReference?.label}}
              </a>
            </li>
          } @else {
            <li soho-popupmenu-item
              [subMenu]="b.showSubMenu"
              (mouseenter)="onCardButtonItemMouseEnter($event)"
              (click)="onCardButtonItemClicked($event)"
              >
              <a soho-popupmenu-label
                attr.data-automation-id="{{b.automationId}}-{{i + 1}}"
                attr.data-row-index="{{i}}"
                attr.data-action-index="{{j}}"
                >
                @if (b.icon) {
                  <svg soho-icon icon="{{b.icon}}"></svg>
                }
                {{b.actionReference?.label}}
              </a>
              <!-- submenu -->
              <!-- Indexes used to lookup data from cardButtonMenus -->
              <!--<ul *ngIf="b.showSubMenu" id="list-view-card-button-sub-menu">-->
              @if (b.showSubMenu) {
                <ul id="list-view-card-button-sub-menu" attr.data-automation-id="{{b.automationId}}-{{i + 1}}-submenu">
                  @for (m of b.relatedActionMenuItems; track m; let k = $index) {
                    <li>
                      <a attr.data-row-index="{{i}}" attr.data-action-index="{{j}}" attr.data-related-index="{{k}}">
                        {{m.text}}
                      </a>
                    </li>
                  }
                </ul>
              }
            </li>
          }
        }
      </ul>
    </div>
  }
}
